/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TumorBoardParticipantOutcome from './tumor-board-participant-outcome';
import TumorBoardParticipantOutcomeDetail from './tumor-board-participant-outcome-detail';
import TumorBoardParticipantOutcomeUpdate from './tumor-board-participant-outcome-update';
import TumorBoardParticipantOutcomeDeleteDialog from './tumor-board-participant-outcome-delete-dialog';

const TumorBoardParticipantOutcomeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TumorBoardParticipantOutcome />} />
    <Route path="new" element={<TumorBoardParticipantOutcomeUpdate />} />
    <Route path=":id">
      <Route index element={<TumorBoardParticipantOutcomeDetail />} />
      <Route path="edit" element={<TumorBoardParticipantOutcomeUpdate />} />
      <Route path="delete" element={<TumorBoardParticipantOutcomeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TumorBoardParticipantOutcomeRoutes;
